import { useQueryClient } from "@tanstack/react-query";
import { useTranslations } from "use-intl";
import { LOCALES, type Locale } from "@liftquest/shared/localized";
import { ToggleGroup, ToggleGroupItem } from "@/components/ui/toggle-group";
import { useLocaleSwitch } from "@/i18n";
import { api } from "@/lib/api";
import { qk } from "@/lib/queries";

export function LanguageSwitch({ className }: { className?: string }) {
  const { locale, setLocale } = useLocaleSwitch();
  const t = useTranslations("languages");
  const qc = useQueryClient();
  return (
    <ToggleGroup
      type="single"
      variant="outline"
      value={locale}
      className={className}
      onValueChange={(v) => {
        if (!v) return;
        setLocale(v as Locale);
        // Remember the choice on the account when signed in (ignored otherwise).
        if (qc.getQueryData(qk.me)) void api.me.profile.$patch({ json: { locale: v } });
      }}
    >
      {LOCALES.map((l) => (
        <ToggleGroupItem key={l} value={l} aria-label={t(l)} className="px-3 font-semibold uppercase">
          {l}
        </ToggleGroupItem>
      ))}
    </ToggleGroup>
  );
}
